<template>
<div class="bg-lime-custom rounded-right" id="travel-login-loaded">
    <div class="container pt-5 pl-5 pb-3 row">
        <div id="main-sidebar-content" class="row m-0 p-0">
            <div class="col-12 p-0 m-0">
                <h2 class="tw-text-24px pb-5 tw-uppercase tw-font-light">Datele asigurării tale de călătorie</h2>
            </div>
            <div class="col-12 row p-0 m-0">
                <div class="col-12 col-lg-6 p-0 m-0">
                    <p class="pb-0 tw-text-16px">Țara</p>
                    <p class="tw-text-18px pb-3 color-brand-4">{{ collector.country_iso_3 }}</p>
                </div>
            </div>
            <div class="col-12 row p-0 m-0">
                <div class="col-12 col-lg-6 p-0 m-0">
                    <p class="pb-0 tw-text-16px">Scopul:</p>
                    <p class="tw-text-18px pb-3 color-brand-4">{{ collector.purpose_name }}</p>
                </div>
            </div>
            <div class="col-12 row p-0 m-0">
                <div class="col-12 col-lg-6 p-0 m-0">
                    <p class="pb-0 tw-text-16px">Mijloc de transport:</p>
                    <p class="tw-text-18px pb-3 color-brand-4">{{ collector.transport }}</p>
                </div>
            </div>
            <div class="col-12 row p-0 m-0">
                <div class="col-12 col-lg-6 p-0 m-0">
                    <p class="pb-0 tw-text-16px">Din data:</p>
                    <p class="tw-text-18px pb-3 color-brand-4">{{ collector.start_date }}</p>
                </div>
            </div>
            <div class="col-12 row p-0 m-0">
                <div class="col-12 col-lg-6 p-0 m-0">
                    <p class="pb-0 tw-text-16px">Până în:</p>
                    <p class="tw-text-18px pb-3 color-brand-4">{{ collector.end_date }}</p>
                </div>
            </div>
        </div>
        <div class="col-12 row p-0 m-0" id="calatori-div" style="display: none"></div>
    </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CollectorData",
  computed: {
    ...mapGetters(['collector']),
  }
}
</script>

<style scoped>

</style>
